import { UpdateStageRequestExoscaleZoneEnum } from "@microtica/ms-engine-sdk";
import { notification } from "antd";
import { getEnvironmentService, getCloudService } from "../backend";
import { ExoscaleZoneType } from "./../types";

/**
 * Connect Exoscale account to Stage
 */
export const linkExoscaleAccountToStage = async ({ envId, projectId, exoscaleAccountId, exoscaleZone }: { envId: string, projectId: string, exoscaleAccountId: string, exoscaleZone?: string }) => {
    try {
        const chosenExoscaleZone = exoscaleZone ?
            UpdateStageRequestExoscaleZoneEnum[exoscaleZone as ExoscaleZoneType] :
            UpdateStageRequestExoscaleZoneEnum.AtVie1;

        await getEnvironmentService().updateStage(
            envId,
            projectId,
            {
                exoscaleAccountId,
                exoscaleZone: chosenExoscaleZone
            }
        );
        notification.success({
            message: "Successfully attached the Exoscale account to your environment"
        });
    } catch (e: any) {
        notification.error({
            message: "Can not attach the Exoscale account",
            description: e?.response?.data ? e.response.data.message : "We had trouble attaching the Exoscale account to your environment. Please contact our support team on support@microtica.com or write on our Discord community channel."
        });
    }
}

/**
 * Fetch Exoscale accounts info for stage and project
 */
export const fetchExoscaleAccountsInfo = async (envId: string, projectId: string): Promise<{ projectExoscaleAccounts: string[], stageExoscaleAccountId: string }> => {
    const [{ exoscaleAccounts }, { exoscaleAccountId }] = await Promise.all([
        getExoscaleAccounts(projectId),
        getStageExoscaleAccount(envId, projectId)
    ]);
    return {
        projectExoscaleAccounts: exoscaleAccounts,
        stageExoscaleAccountId: exoscaleAccountId!
    }
}

const getExoscaleAccounts = async (projectId: string) => {
    try {
        const { data: { exoscaleAccounts } } = await getCloudService().getExoscaleAccounts(projectId);
        return {
            exoscaleAccounts: exoscaleAccounts.map(acc => acc.id)
        };
    } catch (error) {
        return { exoscaleAccounts: [] };
    }
}

const getStageExoscaleAccount = async (envId: string, projectId: string) => {
    try {
        const { data: { exoscaleAccountId } } = await getEnvironmentService().getStage(envId, projectId)
        return { exoscaleAccountId };
    } catch (error) {
        return { exoscaleAccountId: undefined };
    }
}

